import React from 'react';
import Layout from '../components/Layout';

const NotActiveUser = () => {
  return (
    <Layout>
      <div className="d-flex flex-column align-items-center justify-content-center text-center ">
        <div className="card p-4 primary-bg text-white shadow-lg" style={{ maxWidth: '80%' }}>
          <h1 className="mb-4">حسابك غير مفعل</h1>
          <p style={{fontSize:'1.9rem'}}>
             يرجى اتباع الخطوات التالية لتفعيل حسابك:
          </p>
          <ol className="text-start">
            <li style={{fontSize:'1.7rem' }} className='text-end'>
              دخول على صفحة <strong>حسابي بالاعلى على اليمين</strong>.
              <br />
              ثم النزول للأسفل والضغط على زر تحديث بياناتي.
              </li>
              <br />
            <li style={{fontSize:'1.7rem'}} className='text-end'>ملئ البيانات وفق الشروط المطلوبة.</li>
          </ol>
          <p style={{fontSize:'1.2rem' }} className="mt-4">
            شكراً لكم لتفهمكم. 
            <br />
            مع تحيات إدارة بنك راصد.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default NotActiveUser;
